import { makeStyles } from "@material-ui/core/styles";
import bg from "./bg-blue-image.jpg"

export default makeStyles(theme => ({
  container: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: 0,
    insetInlineStart: 0,
    [theme.breakpoints.down("md")]: {
      width: "100%",
      alignItems: "normal",
    },
  },
  logotypeContainer: {
    backgroundColor: theme.palette.primary.main,
    width: "60%",
    height: "100%",
	//marginTop : "75px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      height: "auto"
    },
  },
  loginPage: {
    backgroundColor: theme.palette.primary.main,
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    margin: 0,
    padding: 0,
    backgroundImage: `url(${bg})`,
    position: 'relative',
    zIndex: 1,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    // [theme.breakpoints.down("md")]: {
    //   width: '50%',
    //   display: 'none',
    // },
    "&:after": {
      position: "absolute",
      content: '""', // Added double quotes around content
      top: "0",
      insetInlineStart: "0",
      insetInlineEnd: "0",
      bottom: "0",
      width: "100%",
      height: "100%",
      backgroundImage: 'linear-gradient(270deg, rgba(17, 116, 215, .9), rgba(7, 48, 99, .9) 100%)',
      zIndex: -1,
    },
},

// loginPageAfter: {
//     position: "absolute",
//     content: '',
//     top: "0",
//     left: "0",
//     right: "0",
//     bottom: "0",
//     width: "100%",
//     height: "100%",
//     backgroundImage: 'linear-gradient(270deg, rgba(17, 116, 215, .9), rgba(7, 48, 99, .9) 100%)',
//     zIndex: -1,
// },

loginButton : {
  color: "blue",
  margin: "30px 10px 0",
  /* width: 200px; */
  backgroundColor: "#ffffff",
  fontSize: 18,
  padding: "6px 50px",
  fontWeight: 500,
  borderRadius: "4px",
  '&:hover': {
    color: '#fff',
  },
},
rmlTopSection: {
  position: "absolute",
  top: '1rem',
  padding: "0 20px 0 20px",
  width: "100%",
  [theme.breakpoints.down("xs")]: {
    top: '0.5rem',
      padding: "0 16px",
    },
},
rmlTopLogo: {
  height: "50px",
  [theme.breakpoints.down("xs")]: {
      height: "35px",
    },
},
rmlLogoParent: {
  width: "200px",
  height: "200px",
  marginBottom: "25px",
  display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "1rem",
    [theme.breakpoints.down("xs")]: {
      width: "100px",
      height: "100px",
      marginBottom: "0",
    },
},
  logoParent: {
    width: "200px",
    height: "200px",
    border: "2px solid #9da9e8",
    borderRadius: "50%",
    background: "#fff",
    marginBottom: "25px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "1rem",
    [theme.breakpoints.down("xs")]: {
      width: "100px",
      height: "100px",
    },
  },
  mainText: {
    color: "white",
    fontWeight: 500,
    fontSize: 40,
    // [theme.breakpoints.down("md")]: {
    //   fontSize: 14,
    // },
  },
  logotypeImage: {
    width: "100%",
  },
  logotypeText: {
    color: "white",
    fontWeight: 500,
    fontSize: 40,
    [theme.breakpoints.down("md")]: {
      fontSize: 32,
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: 24,
    },
  },
  divider:{
    border: 'none',
    height: '1px',
    background:  '#fff',
    boxShadow:' 0 1px 1px rgba(0, 0, 0, 0.3)',
    margin: '20px auto',
    width: '40%',
    [theme.breakpoints.down("xs")]: {
      margin: '0',
    },
  },
  logotypeSubText: {
    color: "white",
    fontWeight: 500,
    fontSize: 20,
  },
  formContainer: {
    width: "40%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      height: "auto",
      position: "relative"
    },
  },
  form: {
    marginTop: theme.spacing(6),
    width: 320,
    length: 400,
  },
  tab: {
    fontWeight: 400,
    fontSize: 18,
  },
  greeting: {
    fontWeight: 500,
    textAlign: "center",
    marginTop: theme.spacing(-6),
    [theme.breakpoints.down("xs")]: {
      marginTop: theme.spacing(2),
      fontSize: "2rem"
    },
  },
  subGreeting: {
    // fontWeight: 500,
    textAlign: "center",
    marginTop: theme.spacing(1),
    fontSize: 30,
    color: "white",
  },
  para:{
    color:"white",
    fontSize: 20,
    marginTop: theme.spacing(1),
  },
  googleButton: {
    marginTop: theme.spacing(6),
    boxShadow: theme.customShadows.widget,
    backgroundColor: "white",
    width: "100%",
    textTransform: "none",
  },
  googleButtonCreating: {
    marginTop: 0,
  },
  googleIcon: {
    width: 30,
    marginInlineEnd: theme.spacing(2),
  },
  creatingButtonContainer: {
    marginTop: theme.spacing(2.5),
    height: 46,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  createAccountButton: {
    height: 46,
    textTransform: "none",
  },
  formDividerContainer: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    display: "flex",
    alignItems: "center",
  },
  formDividerWord: {
    paddingInlineStart: theme.spacing(2),
    paddingInlineEnd: theme.spacing(2),
  },
  formDivider: {
    flexGrow: 1,
    height: 1,
    backgroundColor: theme.palette.text.hint + "40",
  },
  errorMessage: {
    textAlign: "center",
    marginTop: theme.spacing(2),
  },
  textFieldUnderline: {
    "&:before": {
      borderBottomColor: theme.palette.primary.light,
    },
    "&:after": {
      borderBottomColor: theme.palette.primary.main,
    },
    "&:hover:before": {
      borderBottomColor: `${theme.palette.primary.light} !important`,
    },
  },
  textField: {
    borderBottomColor: theme.palette.background.light,
  },
  formButtons: {
    width: "100%",
    marginTop: theme.spacing(4),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  forgetButton: {
    textTransform: "none",
    fontWeight: 400,
  },
  loginLoader: {
    marginInlineStart: theme.spacing(4),
  },
  copyright: {
    marginTop: theme.spacing(4),
    whiteSpace: "nowrap",
    [theme.breakpoints.up("md")]: {
      position: "absolute",
      bottom: theme.spacing(2),
    },
  },
  separator: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    margin: theme.spacing(3, 0),
    '&::before, &::after': {
      content: '""',
      flex: 1,
      borderBottom: '1px solid #ccc',
    },
    '&::before': {
      marginInlineEnd: theme.spacing(1.5),
    },
    '&::after': {
      marginInlineStart: theme.spacing(1.5),
    },
    '& span': {
      color: '#666',
      fontWeight: 500,
    },
  },
  awsButton: {
    border: '1px solid #ccc',
    padding: theme.spacing(1),
    textTransform: 'none',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
    width: "100%",
    '&:hover': {
      backgroundColor: '#f0f0f0',
    },

  },
  awsLogo: {
    width: "40px",
    marginInlineEnd: theme.spacing(1),
  },
  switchToAP: {
    position: "absolute",
    top: "2%",
    insetInlineEnd: "2%",
    [theme.breakpoints.down("xs")]: {
      position: "relative",
      top: "unset",
      insetInlineEnd: "unset"
    },
  }
}));
